import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import axios from 'axios';
import { RootState } from '../reduxStore/store';

interface User {
  message: string;
}

interface CurrentUserState {
  user: User | null;
  loading: boolean;
  error: string | null;
}

const initialState: CurrentUserState = {
  user: null,
  loading: false,
  error: null,
};

interface ErrorResponse {
  message: string;
}

// Async thunk to log out the user
export const userLogout = createAsyncThunk<User, void, { rejectValue: ErrorResponse, state: RootState }>(
  'user/logout',
  async (_, thunkAPI) => {
    const token = localStorage.getItem('accessToken');
    console.log("Token for fetching data: " + token);

    if (!token) {
      console.log("No token available");
      return thunkAPI.rejectWithValue({ message: 'No token available' });
    }

    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const response = await axios.post(
        `${apiUrl}/api/v1/auth/logout`,
        null,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("Logout response data:", response.data);
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        console.error("Logout error response:", error.response);
        return thunkAPI.rejectWithValue({ message: error.response.data.message || 'An error occurred' });
      }
      console.error("Logout error:", error);
      return thunkAPI.rejectWithValue({ message: 'An unknown error occurred' });
    }
  }
);

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(userLogout.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(userLogout.fulfilled, (state, action: PayloadAction<User>) => {
        state.loading = false;
        state.user = action.payload;
        state.error = null;
        localStorage.clear(); 
      })
      .addCase(userLogout.rejected, (state, action: PayloadAction<ErrorResponse | undefined>) => {
        state.loading = false;
        state.error = action.payload?.message || 'Unknown error';
      });
  },
});

export default userSlice.reducer;
